import script from "./TableHead.vue?vue&type=script&lang=ts&setup=true"
export * from "./TableHead.vue?vue&type=script&lang=ts&setup=true"

import "./TableHead.vue?vue&type=style&index=0&id=9b42364e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9b42364e"]])

export default __exports__